var i = /* @__PURE__ */ ((m) => (m.NORMAL = "normal", m.MINI = "mini", m.JUMBO = "jumbo", m.MAXI = "maxi", m))(i || {}), o = /* @__PURE__ */ ((m) => (m.NORMAL = "normal", m.MINI = "mini", m.JUMBO = "jumbo", m))(o || {});
export {
  o as i,
  i as o
};
